module.exports = __webpack_public_path__ + "img/pingjia7.44f32e14.png";